import * as types from "../constants/ActionTypes";

const initialState = {
  items: []
}

export const lookupVin = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CALL_CENTER_IVS_VIN_SUCCESS:
      return {
        ...state,
        items: action.payload
      };
    default:
      return state;
  }
}

export const fetchVehicleProperties = (state = {}) => state;

export const fetchCustomer = (state = {}) => state;
